module.exports = __webpack_public_path__ + "static/media/logo-google.b794b239.png";